// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { application } from "./application.js"

// 3rd party libraries
import CheckboxSelectAll from "stimulus-checkbox-select-all"
application.register("checkbox-select-all", CheckboxSelectAll)

import Autosave from 'stimulus-rails-autosave'
application.register('autosave', Autosave)

import Reveal from 'stimulus-reveal-controller'
application.register('reveal', Reveal)

import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

// Load all the controllers within this directory and all subdirectories.
const controllersContext = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(controllersContext))

const componentsContext = require.context("../../components", true, /_controller\.js$/)
application.load(definitionsFromContext(componentsContext))

document.addEventListener('turbo:before-cache', function () {
  application.controllers.forEach(function (controller) {
    if (typeof controller.teardown === 'function') {
      controller.teardown();
    }
  });
});

// Debugging stimulus
// window.Stimulus.debug = true
